import React, { createContext, useContext, useEffect, useState } from 'react'

const LanguageContext = createContext({ lang: 'th', setLang: () => {} })

export function LanguageProvider({ children }) {
  // NOTE: default forced to 'th' (LTR) while the Islamic module is still WIP.
  // Restore 'jawi' default (RTL) once the module is complete.
  const [lang, setLangState] = useState(
    () => localStorage.getItem('islamic-lang') || 'th'
  )

  const setLang = (l) => {
    localStorage.setItem('islamic-lang', l)
    setLangState(l)
  }

  useEffect(() => {
    const rtl = lang === 'jawi'
    document.documentElement.setAttribute('dir', rtl ? 'rtl' : 'ltr')
    document.documentElement.classList.toggle('islamic-rtl', rtl)
  }, [lang])

  return (
    <LanguageContext.Provider value={{ lang, setLang }}>
      {children}
    </LanguageContext.Provider>
  )
}

export const useLanguage = () => useContext(LanguageContext)
